module.exports = __webpack_public_path__ + "static/media/intro.4cf8d267.jpg";